module.exports = __webpack_public_path__ + "assets/webfonts/fa-light-300.eot";